export default ({ width = 24, height = 24, color = "primary" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 51 81"
    >
      <g>
        <g>
          <path
            fill="#FF9F01"
            d="M50.18 49.334c0 13.63-11.05 24.678-24.68 24.678C11.872 74.012.823 62.963.823 49.334c0-13.542 13.836-28.287 21.446-38.705 1.597-2.187 2.396-3.28 3.227-3.283.832-.004 1.642 1.087 3.261 3.269C36.37 20.87 50.18 35.102 50.18 49.334z"
          ></path>
          <path
            fill="url(#paint0_linear_14123_22658)"
            fillOpacity="0.2"
            d="M50.18 49.334c0 13.63-11.05 24.678-24.68 24.678C11.872 74.012.823 62.963.823 49.334c0-13.542 13.836-28.287 21.446-38.705 1.597-2.187 2.396-3.28 3.227-3.283.832-.004 1.642 1.087 3.261 3.269C36.37 20.87 50.18 35.102 50.18 49.334z"
          ></path>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_14123_22658"
          x1="25.501"
          x2="25.501"
          y1="7.346"
          y2="74.012"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.145" stopColor="#fff"></stop>
          <stop offset="0.85" stopColor="#B2460E"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};
